import { jsx as _jsx } from "react/jsx-runtime";
import * as echarts from '@avocadoui/echarts';
import { useEffect, useRef } from 'react';
var charts = {};
var Chart = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '' : _b, options = _a.options;
    var currentId = useRef('');
    var target = useRef(null);
    useEffect(function () {
        // if (id && !charts[id] && options) {
        currentId.current = id;
        charts[id] = echarts.init(target.current);
        charts[id].resize();
        charts[id].setOption(options, true);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, options]);
    useEffect(function () {
        return function () {
            if (charts[currentId.current]) {
                charts[currentId.current].dispose();
                charts[currentId.current] = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx("div", { id: id, ref: target, style: {
            width: '100%',
            height: '100%',
        } }));
};
export default Chart;
